export const BFF_KEY_VALUE = 'ah1MPO-izehIHD-QZZ9y88n-kku876'
